module.exports = __webpack_public_path__ + "static/media/expand.b632c688.svg";